<template>
  <div class="rotate position-absolute opacity-3">
    <svg viewBox="0 0 300 160" height="160">
      <path id="zxxCircle" fill="none" d="M80 75a70 70 0 1 0 140 0a70 70 0 1 0 -140 0z" />
      <text>
        <textPath href="#zxxCircle" fill="#fff">RINGRING • PRETTY • STORE</textPath>
      </text>
    </svg>
  </div>
</template>

<style lang="scss">
textPath {
  letter-spacing: 3px;
  font-weight: bold;
}
</style>
